export default __webpack_public_path__ + "static/media/Rice.0e7a69cb.jpg";